
import { Component, Vue } from 'vue-property-decorator'
import { getStorehouseList, addStorehouse, putStorehouse, delStorehouseList, clearStorehouse } from '@/api/admin'
import { IArticleData } from '@/api/types'
import { Form } from 'element-ui'

@Component({
  name: 'Table'
})

export default class extends Vue {
  private list: IArticleData[] = []
  private listLoading = true
  private dialogFormVisible = false
  private title = '新增仪表'
  private total = 0
  private sub = ''
  private listQuery = {
    page: 1,
    pagesize: 10,
    company: ''
  }
  private initForm = {
    companyNember: '',
    storehouseType: '',
    storehouseAddress: '',
    storehouseName: '',
    storehouseArea: '',
    storehouseLeader: '',
    storehouseLeaderPhone: '',
    storehouseStart: ''
  }
  private form = { ...this.initForm }
  private formLabelWidth = '120px'
  private rules = {
    companyNember: [
      { required: true, message: '请输入企业编号', trigger: 'blur' }
    ],
    storehouseType: [
      { required: true, message: '请选择库房类型', trigger: 'change' }
    ],
    storehouseName: [
      { required: true, message: '请输入库房名称', trigger: 'blur' }
    ],
    storehouseArea: [
      { required: true, message: '请输入库房面积', trigger: 'blur' }
    ],
    storehouseAddress: [
      { required: true, message: '请输入库房详细地址', trigger: 'blur' }
    ],
    storehouseLeader: [
      { required: true, message: '请输入库房负责人', trigger: 'blur' }
    ],
    storehouseLeaderPhone: [
      { required: true, message: '请输入库房负责人电话', trigger: 'blur' }
    ]
  }
  created() {
    this.getList()
  }
  // 列表数据获取
  private async getList() {
    this.listLoading = true
    const { data } = await getStorehouseList(this.listQuery)
    this.list = data.items
    this.total = data.total
    this.listLoading = false
  }
  // 新增 修改
  private async changeHandel(row:any) {
    this.dialogFormVisible = true
    if (row) {
      this.title = '修改仪表'
      this.sub = 'put'
      this.form = row
    } else {
      this.title = '新增仪表'
      this.sub = 'add'
      this.form = this.initForm
    }
  }
  private async clearHandel(id:any) {
    this.$confirm('确定要清空该仓库吗？', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    }).then(() => {
      const res = clearStorehouse({ id })
      if (res) {
        this.$message({
          type: 'error',
          message: '清空仓库失败!'
        })
      } else {
        this.$message({
          type: 'success',
          message: '清空仓库成功!'
        })
        this.getList()
      }
    }).catch(() => {
      this.$message({
        type: 'info',
        message: '清空仓库失败！'
      })
    })
  }
  // 提交
  private async submitHandle() {
    (this.$refs.form as Form).validate(async(valid) => {
      if (valid) {
        if (this.sub === 'add') {
          const res = await addStorehouse(this.form)
          if (res) {
            this.$message({
              type: 'success',
              message: '添加成功!'
            })
          }
        } else {
          const res = await putStorehouse(this.form)
          if (res) {
            this.$message({
              type: 'success',
              message: '修改成功!'
            })
          }
        }
        this.dialogFormVisible = false
      }
    })
  }
  // 删除
  private async delHandel(id:any) {
    this.$confirm('确定要删除该仪表？', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    }).then(() => {
      const res = delStorehouseList({ id })
      if (res) {
        this.$message({
          type: 'success',
          message: '删除成功!'
        })
      }
    }).catch(() => {
      this.$message({
        type: 'info',
        message: '已取消删除'
      })
    })
  }
  // 分页切换
  private async handleCurrentChange(page:any) {
    this.listQuery.page = page
    this.getList()
  }
}
